import React from 'react'
import RowShareOfferAction from 'tennders-market/bin/components/row/action/RowShareOfferAction'
import RowFavouriteAction from 'tennders-market/bin/components/row/action/RowFavouriteAction'
import RowDuplicateAction from 'tennders-market/bin/components/row/RowDuplicateAction'
import { STATUS_READY_TO_PAIR } from 'tennders-stracture/libs/constants'
import DetailHeader from './DetailHeader'

const UnMatchedDetailView = ({ transaction, broker, close }) => (
  transaction ? (
    <DetailHeader
      transaction={transaction}
      item={transaction.matchedLoad || transaction.matchedTruck}
      close={close}
    >
      {broker
      && !transaction?.isCancelled
      && (!transaction.isMarketPlaced || transaction?.status?.label === STATUS_READY_TO_PAIR)
      && (
        <>
          <RowShareOfferAction transaction={transaction} color="white" />
          <div className="pr-10"></div>
          <RowFavouriteAction transaction={transaction} color="white" />
        </>
      )}
      {transaction?.matchedLoad?.internalOwner && (
        <>
          <div className="pr-10" />
          <RowDuplicateAction transaction={transaction} isHeader />
        </>
      )}
    </DetailHeader>
  ) : null
)

export default React.memo(UnMatchedDetailView)
